import { createUseStyles } from "react-jss";
import { ITheme } from "../../../store/slices/theme";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    position: "relative",
  },
  input: {
    border: `1px solid ${theme.colors.Border3}`,
    borderRadius: theme.radius.small,
    minHeight: 48,
    boxSizing: "border-box",
    padding: theme.spacing.space12,
    background: "transparent",
    outline: "none",
    color: theme.colors.TextDefault,
    "&:focus": {
      border: `1px solid ${theme.colors.Border4}`,
    },
    fontSize: 16,
    lineHeight: "24px",
  },
  fullWidth: {
    width: "100%",
  },
  hasStartIcon: {
    paddingInlineStart: theme.spacing.space40,
  },
  startAdornment: {
    marginInlineEnd: theme.spacing.space8,
    position: "absolute",
    insetInlineStart: theme.spacing.space12,
    display: "flex",
    alignItems: "center",
  },
  content: {
    position: "relative",
    cursor: "text",
    display: "flex",
    fontSize: 15,
    alignItems: "center",
  },
  fitContent: {
    width: "fit-content",
  },
  description: {
    paddingTop: theme.spacing.space4,
    padding: `0 ${theme.spacing.space4}px`,
  },
  closeIcon: {
    position: "absolute",
    insetInlineEnd: theme.spacing.space12,
    cursor: "pointer",
    color: theme.colors.TextSilver,
  },
  errorBorder: {
    border: `1px solid ${theme.colors.NotificationError} !important`,
  },
  textDisable: {
    color: theme.colors.TextSilver,
  },
  endAdornment: {
    position: "absolute",
    cursor: "pointer",
  },
  label: {
    paddingBottom: theme.spacing.space4,
  },
}));
